import { Header, Footer, ErrorBoundary } from './components';
import { createHashRouter, Navigate, Outlet } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { ABILITIES, AbilityProvider, routes } from './constants';
import { LoginPage, E404Page, ResetPage } from './pages';

import { connect } from 'react-redux';

class AppRouter extends React.Component {
  getAbilities() {
    return this.props.rank ? ABILITIES[this.props.rank] : {};
  }

  createLoggedInLayout() {
    return (
      <Fragment>
        <AbilityProvider value={this.getAbilities()}>
          <Header />
          <div className="container">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
          <Footer />
        </AbilityProvider>
      </Fragment>
    );
  }

  createRouterConfig() {
    const isLoggedIn = this.props.logged;
    if (isLoggedIn) {
      // Create routes for logged in users
      const allowedRoutes = routes
        .filter(route => route.allowed.indexOf(this.props.rank) !== -1)
        .map(route => ({
          path: route.path,
          element: <route.component />,
        }));

      return createHashRouter([
        {
          path: '/',
          element: this.createLoggedInLayout(),
          children: [
            ...allowedRoutes,
            {
              path: '/login',
              element: <Navigate to="/" replace />,
            },
            {
              path: '*',
              element: <E404Page />,
            },
          ],
        },
      ]);
    } else {
      // Create routes for non-logged in users
      return createHashRouter([
        {
          path: '/login',
          element: <LoginPage />,
        },
        {
          path: '/password/:type',
          element: <ResetPage />,
        },
        {
          path: '*',
          element: <LoginPage />,
        },
      ]);
    }
  }

  render() {
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;

    if (isIE) {
      return (
        <div
          className="container"
          style={{ maxWidth: '600px', margin: '200px auto' }}
        >
          <h1 style={{ marginBottom: '20px' }}>Attention</h1>
          <p>
            Votre navigateur est trop désuet pour supporter cette application.
          </p>
          <p>Veuillez utiliser un navigateur plus récent.</p>
          <div
            style={{
              display: 'flex',
              marginTop: '20px',
              justifyContent: 'flex-start',
            }}
          >
            <a
              style={{
                width: '120px',
                justifyContent: 'center',
                marginRight: '10px',
              }}
              className="button"
              href="https://www.google.com/intl/fr/chrome/"
            >
              Chrome
            </a>
            <a
              style={{ width: '120px', justifyContent: 'center' }}
              className="button"
              href="https://www.mozilla.org/fr/firefox/new/"
            >
              Firefox
            </a>
          </div>
        </div>
      );
    }

    const router = this.createRouterConfig();
    return <RouterProvider router={router} />;
  }
}

const mapStateToProps = state => {
  return {
    logged: state.user.logged,
    rank: state.user.logged ? (state.user.infos.user_type || {}).rang : 0,
  };
};

AppRouter.propTypes = {
  rank: PropTypes.number,
  logged: PropTypes.bool,
};

export default connect(mapStateToProps)(AppRouter);
